const baseState = {
    employees: [],
    loading: true,
    failed: false,
}

export default function reducer(state = baseState, action) {
    switch (action.type) {
        case 'FETCH_EMPLOYEES':
            return {
                ...state,
                loading: true,
                failed: false,
            }
        case 'FETCH_EMPLOYEES_SUCCESS':
            return {
                ...state,
                employees: action.payload,
                loading: false,
                failed: false,
            }
        case 'FETCH_EMPLOYEES_FAILED':
            return {
                ...state,
                failed: true,
                loading: false,
            }
        default:
            return state
    }
}
